import { memo, useMemo } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { PlacesAutocomplete } from 'components/widgets/ProjectInsights/ProjectSearchbar/PlacesAutocomplete';
import { Z_INDEX_DICT } from 'utils/constants/zIndex';

const searchInputContainer = {
  zIndex: Z_INDEX_DICT.MAP_SEARCH_INPUT,
  position: 'relative' as const,
};

const ProjectSearchbar = ({ sx = {} }: { sx?: BoxProps['sx'] }) => {
  const style = useMemo(() => ({ ...searchInputContainer, ...sx }), [sx]);

  return (
    <Box sx={style}>
      <PlacesAutocomplete />
    </Box>
  );
};

export default memo(ProjectSearchbar);
